import { Pipe, PipeTransform } from '@angular/core'
import { en } from '../../../assets/translations/en'

@Pipe({ name: 'mbTranslate', pure: true })

export class MbTranslatePipe implements PipeTransform {
  // Fow now only EN language gets used
  private readonly chunks = en
  private readonly flatChunks: { [key: string]: any[] } = Object.assign({}, ...Object.values(this.chunks).flat())

  transform (inputKey: string, options: any = {}) {
    let translation = this.resolveChunks(inputKey, this.flatChunks) ?? inputKey
    Object.keys(options).forEach((key: string) => {
      translation = translation
        .replaceAll(`{{${key}}}`, options[key])
        .replaceAll(`{{ ${key} }}`, options[key])
    })
    return translation
  }

  resolveChunks (inputKey: string, chunks: {}): string {
    return inputKey
      .split('.')
      .reduce((chunkObj: {}, objItem: string) => chunkObj[objItem as keyof typeof chunkObj] ?? null, chunks)
      .toString()
  }
}
